import { render, staticRenderFns } from "./MarketReport.vue?vue&type=template&id=05f604ae&scoped=true"
import script from "./MarketReport.vue?vue&type=script&lang=js"
export * from "./MarketReport.vue?vue&type=script&lang=js"
import style0 from "./MarketReport.vue?vue&type=style&index=0&id=05f604ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f604ae",
  null
  
)

export default component.exports